import React from "react";
import PropTypes from "prop-types";
import StyledFilterTypeCheckbox from "./FilterTypeCheckboxFlower.styled";
import SVGIcon from "../utility/SVGIcon";

const FilterTypeCheckboxFlower = React.memo(props => {
  const { types, name, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterTypeCheckbox className={`filter-product-type__checkbox ${checked && "is-checked"}`}>
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(types.uri_param, name, types.name)} aria-label={name} type="checkbox" />
      <span className="filter-product-type__checkbox__custom">
        {
            checked ?
                <div className='filter-product-type__checkbox-border'>
                    <SVGIcon name="filter-check" className="filter-product-type__checkbox__svg-checked"/>
                </div> :
                <SVGIcon name="filter-checkbox"/>
        }
      </span>
      <p className="t-body-small filter-product-type__checkbox__copy">{types.name}</p>
    </StyledFilterTypeCheckbox>
  );
});

FilterTypeCheckboxFlower.propTypes = {
  types: PropTypes.object.isRequired,
  checkFilter: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterTypeCheckboxFlower;